import React, { useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { getFullNameUser } from "../../Helpers/Utils/Common";
import moment from "moment";
import { Space } from "antd";

export default function DispatchSlip(props) {
  const componentRef = useRef();
  const {
    table,
    orderItems,
    additionalItems,
    purpose,
    tableTo,
    printerName,
    restoType,
    voidedItems,
    pageAction,
    includeItemRemarks = false,
    foodServer,
    dispatchCounter
  } = props;
  const [finalTable, setFinalTable] = useState(table)
  React.useEffect(() => {
    if (
      purpose === "order slip" ||
      purpose === "cancel" ||
      purpose === "void"
    ) {
      props.setBulkPrintRef(componentRef.current);
    }
  }, []);

  React.useEffect(() => {
    if (table && table.charAt(0)==="G") {
      const tableNumber = table.split('-')[1]
      const tempTable = `GRAB-${tableNumber}`
      setFinalTable(tempTable)
    } else if (table && table.charAt(0)==="F") {
      const tableNumber = table.split('-')[1]
      const tempTable = `FOODPANDA-${tableNumber}`
      setFinalTable(tempTable)
    } else {
      setFinalTable(table)
    }
  }, [table])

  return (
    <div ref={componentRef} className="d-flex justify-content-center">
      <div className="dispatch-receipt">
        <br />
        <br />
        <br />
        <Row className="w-100">{restoType?.toUpperCase()}</Row>
        {purpose !== "transfer" && (
          <Row className="w-100">TABLE # {finalTable?.toUpperCase()}</Row>
        )}
        <Row className="text-center bolder">{purpose?.toUpperCase()}</Row>
        {(purpose==="dispatch" && (pageAction==="order")) && dispatchCounter && (
          <Row>
            <Col className="table-size dispatch-counter-text" align="center">
              {dispatchCounter}
            </Col>
          </Row>
        )}
        {purpose === "transfer" && (
          <Row className="w-100">
            FROM TABLE # {table?.toUpperCase()} TO TABLE #
            {tableTo?.toUpperCase()}{" "}
          </Row>
        )}
        {pageAction &&
          pageAction === "add-item" &&
          purpose === "order slip" && (
            <Row className="text-center bolder">ADDITIONAL ITEMS</Row>
          )}
        {(purpose !== "dispatch" ||
          (purpose === "dispatch" &&
            pageAction !== "add-item" &&
            pageAction !== "void")) && (
          <Row className="mt-3">
            {orderItems?.map((order) => (
              <div>
                <Row className="d-flex justify-content-between">
                  <Col xs={3} className="text-center">
                    {parseInt(order.qty)}
                  </Col>
                  <Col xs={9} className="text-start">
                    {/* {order.set_name && (
                      <>
                        <div>{order.set_name}</div>
                        <div style={{ paddingLeft: "1em" }}>{order.menu_name}</div>
                      </>
                    )} */}
                    {/* {!order.set_name && order.menu_name} */}
                    {order.menu_name}

                    {(order.order_type === "takeout" || order.pricelist === "takeout") && " (TO)"}
                  </Col>
                </Row>
                {order.is_package === "1" && (
                  <div>
                    {order?.menu_details?.map((menu) => (
                      <Row className="d-flex justify-content-between">
                        <Col xs={3} className="text-center"></Col>
                        <Col xs={9} className="text-start">
                          <Space className="ms-4">-{menu.menu_name}</Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
                {order.with_modifier === "1" && (
                  <div>
                    {order?.menu_modifiers?.map((menu) => (
                      <Row className="d-flex justify-content-between">
                        <Col xs={3} className="text-center"></Col>
                        <Col xs={9} className="text-start">
                          <Space className="ms-4">{`  -${menu.modifier_name}`}</Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
                {includeItemRemarks && order.remarks && (
                  <Row className="">
                    <Col xs={3}></Col>
                    <Col xs={9} className="dispatch-item-remarks">
                      {order.remarks}
                    </Col>
                  </Row>
                )}
              </div>
            ))}
          </Row>
        )}

        {additionalItems && additionalItems.length > 0 && (
          <Row className="mt-3">
            <Row className="text-center bolder">ADDITIONAL ITEMS</Row>
            {additionalItems.map((item, index) => (
              <div key={index}>
                <Row className="d-flex justify-content-between">
                  <Col xs={3} className="text-center">
                    {item.counter}
                  </Col>
                  <Col xs={9} className="text-start">
                    {item.name}
                    {item.order_type === "takeout" ||
                    item.pricelist === "takeout"
                      ? "(TO)"
                      : ""}{" "}
                  </Col>
                </Row>
                {item.is_package === "1" && (
                  <div>
                    {item?.menu_details?.map((menu) => (
                      <Row className="d-flex justify-content-between">
                        <Col xs={3} className="text-center"></Col>
                        <Col xs={9} className="text-start">
                          <Space className="ms-4">-{menu.menu_name}</Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
                {item.with_modifier === "1" && (
                  <div>
                    {item?.menu_modifiers?.map((menu) => (
                      <Row className="d-flex justify-content-between">
                        <Col xs={3} className="text-center"></Col>
                        <Col xs={9} className="text-start">
                          <Space className="ms-4">-{menu.modifier_name}</Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
                {includeItemRemarks && item.remarks && (
                  <Row>
                    <Col xs={3}></Col>
                    <Col xs={9} className="dispatch-item-remarks">
                      {item.remarks}
                    </Col>
                  </Row>
                )}
              </div>
            ))}
          </Row>
        )}

        {voidedItems && voidedItems.length > 0 && (
          <Row className="mt-3">
            <Row className="text-center bolder">VOIDED ITEMS</Row>
            {voidedItems.map((item, index) => (
              <>
                <Row className="d-flex justify-content-between" key={index}>
                  <Col xs={3} className="text-center">
                    {item.counter}
                  </Col>
                  <Col xs={9} className="text-start">
                    {item.name}
                    {item.order_type === "takeout" ||
                    item.pricelist === "takeout"
                      ? "(TO)"
                      : ""}{" "}
                  </Col>
                </Row>
                {item.is_package === "1" && (
                  <div>
                    {item?.menu_details?.map((menu, key) => (
                      <Row className="d-flex justify-content-between" key={key}>
                        <Col xs={3} className="text-center"></Col>
                        <Col xs={9} className="text-start">
                          <Space className="ms-4">-{menu.menu_name}</Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
                {item.with_modifier === "1" && (
                  <div>
                    {item?.added_modifiers?.map((menu) => (
                      <Row className="d-flex justify-content-between">
                        <Col xs={3} className="text-center"></Col>
                        <Col xs={9} className="text-start">
                          <Space className="ms-4">-{menu.modifier_name}</Space>
                        </Col>
                      </Row>
                    ))}
                  </div>
                )}
                {includeItemRemarks && item.remarks && (
                  <Row>
                    <Col xs={3}></Col>
                    <Col xs={9} className="dispatch-item-remarks">
                      {item.remarks}
                    </Col>
                  </Row>
                )}
              </>
            ))}
          </Row>
        )}

        {/* {
          (purpose==="dispatch" && (pageAction==="order"||pageAction==="add-item")) && <Row className="mt-4 text-center">{foodServer?.toUpperCase()}</Row>
        } */}
        {/* {purpose === "order slip" && ( */}
          <Row className={`text-center ${purpose!=="dispatch"?"mt-4":""}`}>PRINTER: {printerName}</Row>
        {/* )} */}
        <Row className={`text-center ${(purpose!=="order slip")?"mt-4":""}`}>
          {moment().format("MMM DD, YYYY hh:mm A")}
        </Row>
      </div>
    </div>
  );
}
